import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
   root: {
      '& p': {
         textAlign: 'justify'
      }
    },
    list: {
       alignContent: 'flex-start',
       height: '150px',
       overflowY: 'auto',
       backgroundColor: '#f7f7f7',
       padding: 15,
       margin: '20px 0'
    },
    reason: {
      textAlign: 'left',
      lineHeight: '1px'
    }
})
